import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown, faUserSecret, faShieldHalved, faSackDollar, faBell } from '@fortawesome/free-solid-svg-icons';

const EntryItem = ({ entry, onClick, onRemoveClick, isSelected }) => {
  // Render badge helper using FontAwesome icons
  const renderBadge = (condition, label, icon) =>
    condition === 'true' ? (
      <span className="badge" title={label}>
        <FontAwesomeIcon icon={icon} />
      </span>
    ) : null;

  return (
    <div
      className={`entry-item ${isSelected ? 'selected' : ''}`}
      onClick={(e) => {
        // Only trigger onClick for selection
        if (e.button === 0 && !e.ctrlKey && !e.shiftKey) {
          onClick(e);
        }
      }}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') onClick(e);
      }}
    >
      <img src={entry.chatter.avatar} alt="avatar" className="entry-avatar" />
      {renderBadge(entry.chatter.isOwner, 'Owner', faCrown)}
      {renderBadge(entry.chatter.isStaff, 'Staff', faUserSecret)}
      {renderBadge(entry.chatter.isModerator, 'Mod', faShieldHalved)}
      {renderBadge(entry.chatter.isSubscriber, 'Sub', faSackDollar)}
      &nbsp;
      {/* If selected, force text to black; otherwise use original color */}
      <span style={{ color: isSelected ? '#000' : entry.chatter.color }} className="entry-username">
        {entry.name}
      </span>
      <button
        className="remove-entry-btn"
        onClick={(e) => {
          // Trigger removal only when the X is clicked.
          onRemoveClick(e);
        }}
      >
        &times;
      </button>
    </div>
  );
};

export default EntryItem;
